import { dateFormat } from 'helpers/date';
import { ROLES } from 'helpers/enum';
import { Reducer } from 'redux';
import { UserManageActionTypes } from 'types/actions/userManage';

import { userManageConstant } from '../actionTypes';

export interface UserState {
  role: ROLES;
  username: string;
  first_name: string;
  last_name: string;
  organizationName: string;
  email: string;
  id: string;
  key: string;
  updated_at: string;
  locale?: string;
}

interface UserManageState {
  data: UserState[];
  paginate?: {
    totalPage: number;
    currentPage: number;
  };
  loading: boolean;
  selectedRecord: Partial<UserState>;
  listRoles: ROLES[];
  loadingBtnChangePw: boolean;
  loadingResetPw: boolean;
  isClosePopupResetPw: boolean;
  loadingBtnResetPw: boolean;
}

const initialState: UserManageState = {
  data: [],
  paginate: {
    totalPage: 1,
    currentPage: 1,
  },
  loading: false,
  selectedRecord: {},
  listRoles: [],
  loadingBtnChangePw: false,
  loadingResetPw: false,
  isClosePopupResetPw: false,
  loadingBtnResetPw: false,
};

const userManageReducer: Reducer<UserManageState, UserManageActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case userManageConstant.FETCH_LIST_USER: {
      return {
        ...state,
        loading: true,
      };
    }
    case userManageConstant.UPDATE_STATE_CHANGE_PW: {
      return {
        ...state,
        loadingBtnChangePw: false,
      };
    }
    case userManageConstant.UPDATE_STATE_FORGOT_PW: {
      return {
        ...state,
        loadingResetPw: false,
        isClosePopupResetPw: true,
      };
    }
    case userManageConstant.CHANGE_PW: {
      return {
        ...state,
        loadingBtnChangePw: true,
      };
    }
    case userManageConstant.UPDATE_LIST_USER: {
      const dataSource = action?.payload?.map((e) => {
        return {
          role: e?.role,
          username: e.first_name + ' ' + e.last_name,
          first_name: e.first_name,
          last_name: e.last_name,
          organizationName: e.organization_name,
          email: e.email,
          id: e.id,
          key: e.id,
          locale: e.locale,
          updated_at: dateFormat(e.created_date),
        };
      });

      return {
        ...state,
        data: dataSource,
        paginate: action.paginate,
        loading: false,
      };
    }

    case userManageConstant.CREATE_USER: {
      return {
        ...state,
        loading: true,
      };
    }
    case userManageConstant.DELETE_USER: {
      return {
        ...state,
        loading: true,
      };
    }

    case userManageConstant.UPDATE_USER: {
      const arrayUser = [...state.data];
      const index = arrayUser.findIndex((e) => e.id === action.id);
      if (index !== -1) (arrayUser[index] as any) = action.payload;
      return {
        ...state,
        loading: false,
        data: arrayUser,
      };
    }

    case userManageConstant.SELECT_RECORD: {
      return {
        ...state,
        selectedRecord: action.record,
      };
    }

    case userManageConstant.UPDATE_LIST_ROLES: {
      const list = action?.payload;
      return {
        ...state,
        listRoles: list,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default userManageReducer;
